export function getConsumptionCellKey(cell: { sectorKey: string; subsectorKey?: string | null; energySourceKey: string }): string {
  return `${cell.sectorKey}:${cell.subsectorKey ?? ""}:${cell.energySourceKey}`;
}
